import Time from "../axes/Time";
import FontIconPointPlugin from "../plugins/FontIconPointPlugin";

/**
 * Basic setup for all charts, series might modify chart and axes
 * @type {{type: string, options: {maintainAspectRatio: boolean, legend: {display: boolean}, scales: {xAxes: [*], yAxes: [*]}, tooltips: boolean}}}
 */
let ChartDefault = {
    type: "line",
    options: {
        spanGaps: true,
        responsive: true,
        maintainAspectRatio: false,
        pointHitDetectionRadius : 3,
        legend: {
            display: true,
            position: "bottom",
            labels: {
                usePointStyle: false,
                lineWidth: 0.5,
                borderWidth: 0.5,
                boxWidth: 20,
                generateLabels: function (chart) {
                    let labels = Chart.defaults.global.legend.labels.generateLabels(chart);
                    for (let i in labels) {
                        labels[i].lineWidth = 1;
                    }
                    return labels;
                }
            }
        },
        scales: {
            yAxes: [],
            xAxes: [Time]
        },

        tooltips: {
            displayColors: false,
            bodyFontColor: '#fff',
            titleFontColor: '#fff',
            callbacks: {
                labelTextColor: function(tooltipItem, chart) {
                    return '#fff';
                },
                labelColor:function(tooltipItem, chart) {
                    return '#fff';
                },
                title: (tooltipItem, data) => {
                    return "Values";
                },
                label: (tooltipItem, data) => {
                    let dataset = data.datasets[tooltipItem.datasetIndex];
                    let pointValue = dataset.data[tooltipItem.index];

                    return (
                        tooltipItem.xLabel + " - " +
                        (dataset.tooltipLabelPrefixCallback ? dataset.tooltipLabelPrefixCallback(dataset.label) : dataset.label + ": ")
                        + (dataset.tooltipLabelValueCallback ? dataset.tooltipLabelValueCallback(tooltipItem.yLabel, pointValue) : tooltipItem.yLabel)
                    ).split("\n");
                }
            },
            mode: "x",
            intersect: true,
            position: "nearest",
        },
        hover: {
            mode: 'x',
            intersect: true
        },
        elements: {
            point: {
                radius: 0,
                hitRadius: 8,
                hoverRadius: 4
            }
        }
    },
    plugins: [
        new FontIconPointPlugin()
    ]
};

export default ChartDefault;



// WEBPACK FOOTER //
// ./src/components/chart/channels/ChartDefault.js